import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { Session } from 'src/shared/session';

import { getViewerSignature } from 'src/app/shared/api/signature';

import type { UserInfo } from '../../../types';

import { getUserPetitionInfo } from './userPetitionInfo';

export async function getUserInfo(
	session: Session | undefined,
	slug: string,
	utilityContext: UtilityContext,
): Promise<UserInfo> {
	if (!session) {
		return {
			ownPetition: false,
			canEdit: false,
			signed: false,
		};
	}

	const userId = session.user?.id;
	if (!userId) {
		return {
			ownPetition: false,
			canEdit: false,
			signed: false,
		};
	}

	const [signature, petitionInfo] = await Promise.all([
		getViewerSignature(slug, utilityContext),
		getUserPetitionInfo(slug, utilityContext),
	]);

	const ownPetition = petitionInfo.user.id === userId;
	const canEdit = petitionInfo.viewerCanEdit;

	return {
		ownPetition,
		canEdit,
		signed: !!signature,
	};
}
